import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import { Toast } from 'antd-mobile'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const PAYMENTS_SESSION_PAY = keyMirror({
  SUBMIT_REQUEST: null,
  SUBMIT_SUCCESS: null,
}, 'PAYMENTS_SESSION_PAY')

// ------------------------------------
// Actions
// ------------------------------------
export function submit(payMethod, callback) {
  const token = sessionStorage.getItem('token')
  const iapChallenge = JSON.parse(sessionStorage.getItem('iapChallenge'))
  return dispatch => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: {
          token,
          paymentMethodList: [payMethod],
          iapChallenge,
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          userAgent: navigator.userAgent,
        },
        endpoint: 'cgs/cashdesk/u/pay',
        requestAction: PAYMENTS_SESSION_PAY.SUBMIT_REQUEST,
        successAction: PAYMENTS_SESSION_PAY.SUBMIT_SUCCESS,
        success: function(result) {
          if (!result.bankFormUrl) {
            return Toast.info(
              'Bank validate url get failed, please try again later!'
            )
          }
          document.open()
          document.write(result.bankFormUrl)
          document.close()
        },
        error: function(result) {
          if (result.head.code === '66054') {
            callback(result)
          }
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [PAYMENTS_SESSION_PAY.SUBMIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [PAYMENTS_SESSION_PAY.SUBMIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'paymentsSessionPay',
    reducerMap: {
      paymentsSessionPayState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
